import { FormEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { useDispatch } from "react-redux";
import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { replaceVerificationServiceConfiguration } from "@redux/actions/verification-services-actions";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { archiveVerificationServiceRequest } from "@requests/service-configuration";

type ArchiveVerificationServiceModalProps = {
    onModalClose: () => void;
    verificationServiceConfiguration: FormattedVerificationServiceConfiguration;
};

export const ArchiveVerificationServiceModal = (props: ArchiveVerificationServiceModalProps) => {
    const dispatch = useDispatch();
    const { onModalClose, verificationServiceConfiguration } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);
        const { data, error } = await archiveVerificationServiceRequest(verificationServiceConfiguration.id);
        if (data) {
            displaySuccessModal(
                dispatch,
                resources.requests.archiveVerificationService.success.title,
                resources.requests.archiveVerificationService.success.message
            );

            const newVerificationServiceConfiguration: FormattedVerificationServiceConfiguration = {
                ...verificationServiceConfiguration,
                permissions: {
                    ...verificationServiceConfiguration.permissions,
                    canArchive: false,
                    canRestore: true
                },
                changeRequestID: null,
                changeRequestStatus: null,
                changeRequestType: null,
                status: EntityStatusTypes.INACTIVE
            };

            dispatch(replaceVerificationServiceConfiguration(newVerificationServiceConfiguration));
            onModalClose();
        } else {
            if (error) {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.archiveVerificationService.error.title,
                    resources.requests.archiveVerificationService.error.message,
                    error
                );
            }
            setRequestInProgress(false);
        }
    };

    return (
        <DefaultModal
            automationId="archive-verification-service-modal"
            ariaLabelledBy="archive-verification-service-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"archive-verification-service-title"} closeButton>
                    <Modal.Title>{resources.modals.archiveVerificationService.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {resources.modals.archiveVerificationService.description}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="archive-verification-service-cancel" variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <ButtonWithSpinner
                        id="archive-verification-service-submit"
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.modals.archiveVerificationService.buttons.archiveService.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};